module.exports = __webpack_public_path__ + "img/tyco.4b40d37a.png";